import {Injectable} from '@angular/core';
import {environment} from '../../../environments/environment';
import {Helper} from '../../helpers/helper.service';
import {HttpClient, HttpParams, HttpResponse} from '@angular/common/http';
import {map, catchError} from 'rxjs/operators';

@Injectable()
export class InvoiceService {
  constructor(private helper: Helper, private http: HttpClient) {
  }

  public getInvoices(gridData = new HttpParams(), params = new HttpParams(), scope = 'dealer-system') {
    return this.http.get<any>(environment.apiUrl + '/' + scope + '/invoice/?' + gridData.toString())
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public getPdfInvoice(invoiceId) {
    return this.http.get(environment.apiUrl + '/dealer-system/invoice/' + invoiceId + '/pdf', {
      responseType: 'arraybuffer' as 'json',
      observe: 'response'
    }).pipe(
      map((resp: HttpResponse<ArrayBuffer>) => this.helper.fileDownloadMap(resp, true)),
      catchError(error  => this.helper.catchError(error ))
    );
  }

  public getPdf(invoiceId) {
    return this.http.get(environment.apiUrl + '/dealer-system/invoice/' + invoiceId + '/pdf', {
      responseType: 'arraybuffer' as 'json',
      observe: 'response'
    }).pipe(
      map((resp: HttpResponse<ArrayBuffer>) => {
        const contentDispositionHeader = resp.headers.get('content-disposition');
        const result = contentDispositionHeader.split(';')[1].trim().split('=')[1];
        return {'url': window.URL.createObjectURL(new Blob([resp.body], {type: 'application/pdf'})), 'filename': result.replace(/"/g, '')};
      }),
      catchError(res => this.helper.catchError(res))
    );
  }

  public downloadInvoices(gridData = new HttpParams()) {
    return this.http.get(environment.apiUrl + '/dealer-system/invoice/download?' + gridData.toString(), {
      responseType: 'arraybuffer' as 'json'
    }).pipe(
      catchError(error  => this.helper.catchError(error ))
    );
  }
}
